import { render, staticRenderFns } from "./FrequencyTable.vue?vue&type=template&id=25e3163f&scoped=true"
import script from "./FrequencyTable.vue?vue&type=script&lang=ts"
export * from "./FrequencyTable.vue?vue&type=script&lang=ts"
import style0 from "./FrequencyTable.vue?vue&type=style&index=0&id=25e3163f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e3163f",
  null
  
)

export default component.exports